import { render, staticRenderFns } from "./MinimalPaidPlan.vue?vue&type=template&id=3763c66e&"
import script from "./MinimalPaidPlan.vue?vue&type=script&lang=js&"
export * from "./MinimalPaidPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports